import {
    InvoiceItem,
    InvoiceItemClassification,
    InvoiceItemInventory,
    InvoiceItemPrices,
    InvoiceItemService,
    InvoiceItemType,
    InvoiceItemTypes,
    PriceBreak,
    UnitOfMeasure,
} from '../../../datasource/invoiceItems';
import { TypeHelpOptions, Exclude } from 'class-transformer';

class CornerstoneInvoiceItemPrices extends InvoiceItemPrices {
    @Exclude()
    itemTypeId: string;

    constructor(values?: TypeHelpOptions) {
        super();
        this.itemTypeId = values?.newObject?.itemType?.id;
    }

    minimumPrice: number;

    dispensingFee?: number;

    markupPercentage: number;

    priceBreaks: PriceBreak[] = [];
}

class CornerstoneInvoiceItemUnitOfMeasure extends UnitOfMeasure {
    pimsGeneratedId: string;
}

class CornerstoneInvoiceItemInventory extends InvoiceItemInventory {
    unitOfMeasure?: CornerstoneInvoiceItemUnitOfMeasure = new CornerstoneInvoiceItemUnitOfMeasure();
}

class CornerstoneInvoiceItemClassification extends InvoiceItemClassification {
    pimsGeneratedId: string;
}

class CornerstoneInvoiceItemSubClassification extends InvoiceItemClassification {
    pimsGeneratedId: string;
}

class CornerstoneInvoiceItemType extends InvoiceItemType {
    id: InvoiceItemTypes;
}

export class CornerstoneInvoiceItem extends InvoiceItem {
    classification: CornerstoneInvoiceItemClassification = new CornerstoneInvoiceItemClassification();

    subClassification: CornerstoneInvoiceItemSubClassification | null = null;

    pimsId: string;

    hospitalDescription: string;

    prices: CornerstoneInvoiceItemPrices = new CornerstoneInvoiceItemPrices();

    itemType: CornerstoneInvoiceItemType = new CornerstoneInvoiceItemType();

    typeDetails: CornerstoneInvoiceItemInventory | InvoiceItemService = {};
}
